import { render, staticRenderFns } from "./TagReveal.vue?vue&type=template&id=0651baa7&scoped=true&"
import script from "./TagReveal.vue?vue&type=script&lang=js&"
export * from "./TagReveal.vue?vue&type=script&lang=js&"
import style0 from "./TagReveal.vue?vue&type=style&index=0&id=0651baa7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0651baa7",
  null
  
)

export default component.exports